import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { mtLrftUrl } from "../config";
import { auth } from "../Authentication/Authentication";

export default function PaiementStripeForm(props) {
	const [succeeded, setSucceeded] = useState(false);
	const [error, setError] = useState(null);
	const [processing, setProcessing] = useState("");
	const [disabled, setDisabled] = useState(true);
	const [clientSecret, setClientSecret] = useState("");
	const stripe = useStripe();
	const elements = useElements();

	// useEffect(() => {
	// 	const idTransaction = sessionStorage.getItem("idTransaction");

	// 	const tokenPublic = "cHVibGljOjk4SE85SE9JVUdPSTk4SA==";
	// 	const defaultHeaders = {
	// 		Accept: "application/json",
	// 		"Content-Type": "application/json",
	// 		Authorization: "Basic " + tokenPublic
	// 	};
	// 	window
	// 		.fetch(mtLrftUrl + "/public/abonnements/transaction/" + idTransaction, {
	// 			method: "GET",
	// 			headers: defaultHeaders
	// 			// body: JSON.stringify({items: [{ id: "xl-tshirt" }]})
	// 		})
	// 		.then(res => {
	// 			return res.json();
	// 		})
	// 		.then(data => {
	// 			setClientSecret(data.data.idIntentClientSecretStripe);
	// 		});
	// }, []);

	useEffect(() => {
		const fetchTransaction = async () => {
			const idTransaction = sessionStorage.getItem("idTransaction");

			try {
				// 🔑 Récupération du token (via refresh_token)
				const accessToken = await auth.getAccessToken();
				if (!accessToken) {
					console.error("Impossible de récupérer l'access token");
					return;
				}

				const response = await fetch(
					mtLrftUrl + "/public/abonnements/transaction/" + idTransaction,
					{
						method: "GET",
						headers: {
							Accept: "application/json",
							"Content-Type": "application/json",
							Authorization: `Bearer ${accessToken}` // 👈 remplacement ici
						}
					}
				);

				if (!response.ok) {
					console.error("Erreur API transaction:", response.status);
					return;
				}

				const data = await response.json();
				setClientSecret(data.data.idIntentClientSecretStripe);
			} catch (err) {
				console.error("Erreur fetch transaction:", err);
			}
		};

		fetchTransaction();
	}, []);

	const cardStyle = {
		hidePostalCode: true,
		style: {
			base: {
				color: "#32325d",
				fontFamily: "Arial, sans-serif",
				fontSmoothing: "antialiased",
				fontSize: "16px",
				"::placeholder": {
					color: "#32325d"
				}
			},
			invalid: {
				color: "#fa755a",
				iconColor: "#fa755a"
			}
		}
	};

	const handleChange = async event => {
		// Listen for changes in the CardElement
		// and display any errors as the customer types their card details
		setDisabled(event.empty);
		setError(event.error ? event.error.message : "");
	};

	const handleSubmit = async ev => {
		ev.preventDefault();
		setProcessing(true);

		const payload = await stripe.confirmCardPayment(clientSecret, {
			payment_method: {
				card: elements.getElement(CardElement),
				billing_details: {
					name: ev.target.name.value
				}
			}
		});

		if (payload.error) {
			setError(`Payment failed ${payload.error.message}`);
			setProcessing(false);
			props.self.setState({
				messageModal: (
					<>
						Votre paiement n'a pas pu être effectué, veuillez réessayer plus
						tard ou nous contacter via la page contact
					</>
				),
				showModal: true
			});
		} else {
			console.log(payload);

			const fetchTransaction = async payload => {
				const idTransaction = sessionStorage.getItem("idTransaction");
				let createPaymentResponse = {
					clientSecret: payload.paymentIntent.client_secret,
					statusApresPaiement: payload.paymentIntent.status,
					montantPaye: payload.paymentIntent.amount
				};

				try {
					// 🔑 Récupération du token (via refresh_token)
					const accessToken = await auth.getAccessToken();
					if (!accessToken) {
						console.error("Impossible de récupérer l'access token");
						return;
					}

					const response = await fetch(
						`${mtLrftUrl}/public/abonnements/transaction`,
						{
							method: "PUT",
							body: JSON.stringify(createPaymentResponse),
							headers: {
								Accept: "application/json",
								"Content-Type": "application/json",
								Authorization: `Bearer ${accessToken}` // 👈 remplacement ici
							}
						}
					);

					if (!response.ok) {
						console.error("Erreur API transaction:", response.status);
						return;
					}

					const data = await response.json();
					console.log(data);
					sessionStorage.setItem("idDonation", data.id);
					this.setState({
						messageEntete: "Paiement par carte bancaire",
						formulaireDonSubmited: true,
						choixMenuFormulairePaiement: 2
					});
				} catch (err) {
					console.error("Erreur fetch transaction:", err);
				}
			};

			fetchTransaction(payload);

			setError(null);
			setProcessing(false);
			setSucceeded(true);
			props.self.setState(
				{
					messageModal: (
						<>
							Votre paiement a bien été effectué, vous recevrez un E-Mail de
							confirmation.
							<br />
							Merci
						</>
					),
					showModal: true,
					reloadPage: true
				},
				() => {
					sessionStorage.removeItem("idTransaction");
					sessionStorage.removeItem("tabFormulaire");
					sessionStorage.removeItem("montantAPayer");
				}
			);
		}
	};

	return (
		<>
			<form id="payment-form" onSubmit={handleSubmit}>
				<CardElement
					id="card-element"
					options={cardStyle}
					onChange={handleChange}
				/>

				<button
					disabled={processing || disabled || succeeded}
					id="submit"
					style={{}}
					className="mt-4"
				>
					<span id="button-text">
						{processing ? (
							<div className="spinner" id="spinner"></div>
						) : (
							"Payer"
						)}
					</span>
				</button>
			</form>
		</>
	);
}
